import {
  ActionSheet,
  Button,
  Cell,
  Collapse,
  CollapseItem,
  CountDown,
  DatetimePicker,
  Dialog,
  Field,
  Form,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  Icon,
  Image as VanImage,
  Lazyload,
  List,
  Loading,
  Picker,
  Popover,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Stepper,
  Swipe,
  SwipeItem,
  Switch,
  Tab,
  Tabs,
  Toast,
  TreeSelect,
  SwipeCell,
  Checkbox,
  CheckboxGroup,
  Row,
  Col,
  ImagePreview,
  Calendar,
  Progress,
  Grid,
  GridItem
} from 'vant'
import Vue from 'vue'

Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Progress)
Vue.use(Calendar)
Vue.use(ImagePreview)
Vue.use(Row)
Vue.use(Col)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(SwipeCell)
Vue.use(PullRefresh)
Vue.use(CollapseItem)
Vue.use(Collapse)
Vue.use(Cell)
Vue.use(Popover)
Vue.use(Popup)
Vue.use(TreeSelect)
Vue.use(Switch)
Vue.use(List)
Vue.use(Popup)
Vue.use(Stepper)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(VanImage)
Vue.use(Loading)
Vue.use(GoodsAction)
Vue.use(GoodsActionButton)
Vue.use(GoodsActionIcon)
Vue.use(Lazyload)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Picker)
Vue.use(CountDown)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)

Vue.prototype.$toast = Toast
Vue.prototype.$dailog = Dialog
